jQuery("#carousel").owlCarousel({
  autoplay: true,
  margin: 20,
  responsiveClass: true,
  autoplayHoverPause: true,
  autoHeight: true,
  autoplayTimeout: 5000,
  smartSpeed: 1000,
  nav: false,
  loop: true,
  responsive: {
    0: {
      items: 1,
    },

    600: {
      items: 2,
    },

    1024: {
      items: 3,
    },

    1366: {
      items: 3,
    },
  },
});

// product Gallery
var main_img = document.querySelector("#current");
var images = document.querySelectorAll(".images img");
images.forEach((img) => img.addEventListener("click", imgClick));
function imgClick(e) {
  images.forEach((img) => (img.style.opacity = 1));
  main_img.classList.add("fadeIn");
  setTimeout(() => main_img.classList.remove("fadeIn"), 500);
  main_img.src = e.target.src;
  e.target.style.opacity = 0.6;
}
// about-us
$(".card-slider-one").owlCarousel({
  loop: false,
  margin: 50,
  items: 3,
  nav: false,
  navText: [
    "<i class='fa-solid fa-angle-left'></i>",
    "<i class='fa-solid fa-angle-right'></i>",
  ],
  dots: false,
  responsive: {
    0: {
      items: 1,
      nav: true,
    },
    600: {
      items: 2,
    },
    1000: {
      items: 3,
    },
  },
});

var screenWidth = $(window).width();

var galleryImg = $("div.galleryImg");

var mainImg = $("div.focusImg");

if (screenWidth < 767) {
  galleryImg.insertAfter(mainImg);
}
// collections 
jQuery("#collections").owlCarousel({
  autoplay: true,
  margin: 30,
  responsiveClass: true,
  autoplayHoverPause:true,
  autoHeight: true,
  autoplayTimeout: 5000,
  smartSpeed: 1000,
  nav: false,
  loop: true,
  dots: true,
  responsive: {
    0: {
      items: 1
    },

    600: {
      items: 2
    },

    1024: {
      items: 3
    },

    1366: {
      items: 3
    }
  }
});


$('.collection-product-slider').owlCarousel({
 autoplay: false, 
  responsiveClass: true,
  autoplayHoverPause:true,
  autoHeight: true,
  autoplayTimeout: 5000,
  smartSpeed: 1000,
  nav: true,
  dots: true,
  loop: true,  
  responsive: {
    0: {
      items: 1,
      dots: false,
      nav: true  
    },

    600: {
      items: 2,
      dots: false,
      margin: 30
    },

    1024: {
      items: 3,
      dots: false,
      margin: 40
    },

    1366: {
      items: 3,
      dots: false,
       margin: 60
    }
  }
});

$(document).ready(function() {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if (target.length) {
        // Set offset based on screen width
        var offset = $(window).width() <= 768 ? 40 : 110;

        $('html, body').animate({
          scrollTop: target.offset().top - offset
        }, 1000);

        return false;
      }
    }
  });
});

/// maria js custom
if(jQuery('.sf-bestseller-grids').length) {
  var bestsellerswiper = new Swiper(".sf-bestseller-grids", {
    slidesPerView: 1,
    autoHeight:true,
    breakpoints: {
      767: {
        slidesPerView: 3,
      }
    },
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

if(jQuery('.sf-column-grids-slider').length) {
    
  let sfslidesvar = 1;

    const sfclasses = document.querySelector('.sf-column-grids-slider').classList;

    if (sfclasses.contains("s_c6")) sfslidesvar = 2;
    if (sfclasses.contains("s_c4")) sfslidesvar = 3;
    if (sfclasses.contains("s_c3")) sfslidesvar = 4;

  var sfgridscolumnswiper = new Swiper(".sf-column-grids-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      767: {
        slidesPerView: sfslidesvar,
      }
    },
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".sw-top-btn-next",
        prevEl: ".sw-top-btn-prev",
    },
  });
}

if(jQuery('.sf-video-swiper').length) {
  const sfVideoSwiper = new Swiper('.sf-video-swiper', {
    slidesPerView: 1.8,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      767: {
        slidesPerView: 4,
        centeredSlides: false,
      }
    },
    autoplay: {
      delay: 3000,
    },
    on: {
      init() {
        handleVideos(this);
      },
      slideChange() {
        handleVideos(this);
      }
    }
  });

  function handleVideos(sfswiper) {
    sfswiper.slides.forEach(sfslide => {
      const sfvideo = sfslide.querySelector('video');
      if (!sfvideo) return;

      if (sfslide.classList.contains('swiper-slide-visible')) {
        sfvideo.muted = true;
        sfvideo.play().catch(() => {});
      } else {
        //sfvideo.pause();
        sfvideo.muted = true;
        sfvideo.play().catch(() => {});
      }
    });
  }
}